var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"redirect-box"},[_c('p',[_vm._v("当前打开路由\""+_vm._s(_vm.route)+"\"为新路由, 请在新前端系统打开此路由")]),_c('p',[_vm._v("若仍需访问，请手动点击路由地址"),_c('a',{attrs:{"href":_vm.origin}},[_vm._v(_vm._s(_vm.origin))]),_vm._v(" 打开")])])
}
var staticRenderFns = []

export { render, staticRenderFns }